import React, { useRef, useState } from "react";

const SpeakerTestSection = ({ onNext }) => {
  const audioRef = useRef();

  const [isPlaying, setIsPlaying] = useState(false);

   const togglePlay = () => {
    const audio = audioRef.current;

    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
    }
  };

  const handleNextClick = async () => {
    setIsPlaying(false);
    onNext();
  };

  return (
    <>
      <div className="language-left-section" style={{gap:'10px'}}>
        <img src="/images/speaker-gray.svg" alt="speaker" />
        <h4>Test your speakers</h4>
        <p>Click the play button to play the recorded audio</p>
      </div>
      <div className="language-right-section">
        <div className="wight-mic-bg">
          <img className="mic-img" src={isPlaying ? "/images/pause-icon.svg" : "/images/play-icon.svg"} alt="" width={52} height={52} onClick={togglePlay}  />
        </div>
        <audio ref={audioRef} controls src="/images/digital_revolution_listening.mp3" style={{ display: "none" }} onEnded={() => setIsPlaying(false)} />
        <p>If recording is ok, click next</p>
        <div className="controls">
          <button className="primary" onClick={handleNextClick}>Next</button>
        </div>
      </div>
    </>
  );
};

export default SpeakerTestSection;
